import React from "react";
import { motion } from "framer-motion";
import {
  FaLock,
  FaServer,
  FaUserSecret,
  FaMicrochip,
  FaCoins,
  FaProjectDiagram,
} from "react-icons/fa";

const Features = () => {
  return (
    <section id="features" className="py-16 px-6 bg-cover bg-center relative">
      <div className="absolute inset-0 bg-black bg-opacity-80"></div>

      <div className="relative max-w-7xl mx-auto text-center">
        <motion.h2
          className="text-4xl font-bold text-yellow-400 mb-10 inline-block border-b-4 border-red-600 px-4 pb-2"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Main Features
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              title: "Immutability",
              icon: <FaLock className="text-blue-500 text-5xl" />,
              description:
                "Blocks added to the Menelik blockchain are virtually unalterable due to hash encryption, ensuring data integrity.",
            },
            {
              title: "Smartnodes & ChainLock",
              icon: <FaServer className="text-green-500 text-5xl" />,
              description:
                "Smartnodes host full copies of the blockchain, providing additional services and enhancing security.",
            },
            {
              title: "CoinJoin",
              icon: <FaUserSecret className="text-purple-500 text-5xl" />,
              description:
                "Menelik utilizes CoinJoin to merge transactions, obscuring the origin of funds and ensuring greater privacy.",
            },
            {
              title: "ASIC Resistance",
              icon: <FaMicrochip className="text-red-500 text-5xl" />,
              description:
                "Through the GhostRider algorithm, Menelik promotes decentralization and fairness by making ASIC mining difficult.",
            },
            {
              title: "Smartnode Investment",
              icon: <FaCoins className="text-yellow-500 text-5xl" />,
              description:
                "Smartnodes are specialized nodes that perform essential functions and offer rewards to operators, ensuring network stability.",
            },
            {
              title: "Consensus Algorithm",
              icon: <FaProjectDiagram className="text-indigo-500 text-5xl" />,
              description:
                "Menelik utilizes a combination of PoW and PoS to ensure fast and secure transactions, reinforcing overall network security.",
            },
          ].map((feature, index) => (
            <motion.div
              key={index}
              className="bg-gray-900 bg-opacity-50 p-6 rounded-xl shadow-lg backdrop-blur-lg flex items-start space-x-6 border-l-4 border-yellow-500 hover:border-red-600 transition-all duration-300 transform hover:-translate-y-2"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              {feature.icon}
              <div>
                <h3 className="font-semibold text-xl mb-2 text-yellow-400">
                  {feature.title}
                </h3>
                <p className="text-gray-300">{feature.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
